import { useState, useEffect } from 'react';
import { useValUserT1 } from 'newHooks/useValUserT1'
import { decodeStorage } from 'newFunctions/storageBase64';
import { BASE_PATH_API, BASE_PATH_API_DEV, STAGE_DIRNAME, TIMEOUT_TIME } from 'constants/general';
import { formatResponse } from 'newFunctions/formatResponse';

export function useCardsListT1(){

    const { tokenT1Card } = useValUserT1()
    const [ cardsResponse , setCardsResponse ] = useState()
    const [ cardsArray , setCardsArray ] = useState()
    const [ udArray, setUdArray ] = useState(false)
    const token = decodeStorage('access_token')

    const getCardsT1 = async (tokenClienteT1) => {
        let apiURL
        try {
            if(STAGE_DIRNAME === "dev"){
                // apiURL = `${BASE_PATH_API_DEV?.userProfile}/t1pagos/v2/clients/${tokenClienteT1}/cards`
                apiURL = `${BASE_PATH_API}/t1pagos/v2/clients/${tokenClienteT1}/cards`
            }else{
                apiURL = `${BASE_PATH_API}/t1pagos/v2/clients/${tokenClienteT1}/cards`
            }

            const config = {
                method: 'GET',
                timeout: TIMEOUT_TIME,
                withCredentials: false,
                crossdomain: true,
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': `Bearer ${token}`
                }
            };

            const response = await fetch(apiURL, config);
            const data = await formatResponse(response)
            setCardsResponse(data);

        } catch (error) {
            console.error('Error fetching cards:', error);
            throw error;
        }
    }


    useEffect(()=>{
        if(tokenT1Card){
            getCardsT1(tokenT1Card)
            setUdArray(false)
        }
    },[tokenT1Card, udArray])

    useEffect(()=>{
        if(cardsResponse){
            if(cardsResponse.statusCode === 200){
                if(cardsResponse.data){
                    if(cardsResponse.data.data){
                        setCardsArray(cardsResponse.data.data)
                    }
                }
            }
        }
    },[cardsResponse])


    const updateArrayCards = (val) =>{
        setUdArray(val)
    }

    return{
        cardsArray,
        updateArrayCards
    }
}

export function useCardAddT1(){

    const [formDataCard, setFormDataCard] = useState()
    const [cardData, setCardData] = useState()

    useEffect(()=>{
        if(formDataCard){
            setCardData(formDataCard)
        }
    },[formDataCard])

    const addCardData = (value) => {
        setFormDataCard(value)
    }

    return{
        cardData,
        addCardData
    }
}